import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18MessageC = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M9.16 4C6.33 4 4 5.954 4 8.41c0 2.455 2.328 4.4 5.16 4.4l.318-.007q.318-.016.632-.066l.078-.014-.187-.148a5.5 5.5 0 0 0 1.925 1.034.702.702 0 0 0 .81-1.014l-.118-.21a4 4 0 0 1-.194-.434l-.034-.098.017-.01a4.26 4.26 0 0 0 1.913-3.416C14.32 5.954 11.99 4 9.16 4m0 1c2.313 0 4.16 1.549 4.16 3.41a3.25 3.25 0 0 1-1.751 2.767.5.5 0 0 0-.255.56l.078.285q.043.14.095.28l.03.073-.02-.009a4.5 4.5 0 0 1-.858-.56.5.5 0 0 0-.423-.105 5 5 0 0 1-1.054.109C6.844 11.81 5 10.269 5 8.41 5 6.549 6.847 5 9.16 5"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18MessageC$1 = Svg18MessageC;

export { Svg18MessageC$1 as default };
